<template>
	<div class=''>
		<Input class='input-white'
            placeholder='Title' name='title' label='Title'
            v-model:value='value.title'
        />

        <Textarea name='description' class='mt-4 transition-all duration-500 ease-in-out'
        	placeholder='Description' label='Description'
        	v-model:value='value.description'
        	rows='5'
			:textareaClass='["transition-all duration-500 ease-in-out", {
				"min-h-[254px]": size,
				"min-h-[134px]": !size,
			}]'
		/>

		<DateInput class='mt-4'
			name='starts_at'
			label='Start'
			v-model:value='value.starts_at'
		/>

		<div class='grid lg:grid-cols-2 gap-4 mt-4' v-if='create != "task"'>
	        <Select class='input-white'
	            placeholder='Duration' name='duration' label='Duration'
	            :options='durations'
	            v-model:value='value.duration'
	        />
	    </div>
	</div>
</template>

<script>
	import Event from '~/models/event.js';

	export default {
		props: {
			size: Boolean,
			editing: {
				type: Object,
				default: null
			},
			create: { type: String, default: 'task' }
		},

		data() {
			return {
				value: Event.form(this.editing),

				durations: [
					{ value: 0, html: 'None' },
					{ value: 5, html: '5 minutes' },
					{ value: 10, html: '10 minutes' },
					{ value: 15, html: '15 minutes' },
					{ value: 25, html: '25 minutes' },
					{ value: 30, html: '30 minutes' },
					{ value: 45, html: '45 minutes' },
					{ value: 60, html: '1 hour' },
					{ value: 90, html: '1 hour 30 minutes' },
					{ value: 120, html: '2 hours' },
					{ value: 150, html: '2 hours 30 minutes' },
					{ value: 180, html: '3 hours' },
					{ value: 1440, html: 'All day' },
				]
			}
		},

		components: {
            // 'LongDatePicker': require('~/components/customer/input/long-date').default,
            // 'Calendar': require('~/components/customer/misc/calendar').default
        }
	}
</script>